import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { LanguageData, selectLanguageData } from '../../store/slices/language.slice';

export const useLanguageData = () => useSelector<RootState, LanguageData>(selectLanguageData);
